<div
  class="hotkeys-cheatsheet-container fade"
  [ngClass]="{ 'in': showCheatsheet }"
  role="dialog"
  aria-modal="true"
  aria-labelledby="hotkeys-cheatsheet-title"
  tabindex="-1"
>
  <div
    class="hotkeys-cheatsheet-content"
  >
    <h4 class="hotkeys-cheatsheet-title">Keyboard Shortcuts:</h4>
    <table>
      <tbody>
        <tr>
          <th></th>
        </tr>
        <tr *ngFor="let hotkey of allHotkeys">
          <td class="hotkeys-keys"><span class="keys">{{ hotkey.combo }}</span></td>
          <td class="description">{{ hotkey.description }}</td>
        </tr>
      </tbody>
    </table>
    <div
      (click)="closeCheatsheet()"
      aria-label="Close cheatsheet"
      class="hotkeys-close"
      role="button"
      (keydown.enter)="closeCheatsheet()"
      tabindex="-1"
    >
      &#215;
    </div>
  </div>
</div>
